import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "analytics",
  "use": "analytics-usage",
  "viewBox": "0 0 27 30",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 27 30\" id=\"analytics\"><path d=\"M19.625 3.58v22.5c0 2.517 1.739 3.92 3.58 3.92 1.704 0 3.58-1.193 3.58-3.92V3.75c0-2.308-1.705-3.75-3.58-3.75s-3.58 1.59-3.58 3.58z\" fill=\"#F9AB00\" /><path d=\"M10.25 15v11.08c0 2.518 1.739 3.92 3.58 3.92 1.704 0 3.58-1.193 3.58-3.92V15.17c0-2.307-1.705-3.75-3.58-3.75s-3.58 1.591-3.58 3.58zM4.455 30a3.58 3.58 0 100-7.158 3.58 3.58 0 000 7.159z\" fill=\"#E37400\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol